import React from "react";
import ReactDOM from "react-dom";
import * as Icon from "react-feather";

import "./tools-row-menu.css";

import WComponent from "../../../common/WComponent";

class ToolsRowMenu extends WComponent {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
			menuRect: null,
		};

		this.triggerRef = React.createRef();
		this.menuRef = React.createRef();
	}

	componentWillUnmount() {
		this.detachListeners();
	}

	attachListeners = () => {
		document.addEventListener("mousedown", this.onDocumentMouseDown);
		document.addEventListener("keydown", this.onDocumentKeyDown);
		window.addEventListener("resize", this.closeMenu);
		window.addEventListener("scroll", this.closeMenu, true);
	};

	detachListeners = () => {
		document.removeEventListener("mousedown", this.onDocumentMouseDown);
		document.removeEventListener("keydown", this.onDocumentKeyDown);
		window.removeEventListener("resize", this.closeMenu);
		window.removeEventListener("scroll", this.closeMenu, true);
	};

	onDocumentMouseDown = event => {
		const insideTrigger = this.triggerRef.current && this.triggerRef.current.contains(event.target);
		const insideMenu = this.menuRef.current && this.menuRef.current.contains(event.target);
		if (!insideTrigger && !insideMenu) this.closeMenu();
	};

	onDocumentKeyDown = event => {
		if (event.key === "Escape") this.closeMenu();
	};

	computeMenuRect = () => {
		const triggerElement = this.triggerRef.current;
		if (!triggerElement) return null;

		const rect = triggerElement.getBoundingClientRect();
		const distanceFromRightEdge = Math.max(8, window.innerWidth - rect.right);
		return { top: rect.bottom + 4, right: distanceFromRightEdge };
	};

	openMenu = async () => {
		this.attachListeners();
		await this.update({ isOpen: true, menuRect: this.computeMenuRect() });
	};

	closeMenu = async () => {
		this.detachListeners();
		await this.update({ isOpen: false });
	};

	toggleMenu = () => {
		if (this.state.isOpen) {
			this.closeMenu();
		} else {
			this.openMenu();
		}
	};

	onChooseItem = item => {
		this.closeMenu();
		item.onClick();
	};

	renderItem = item => {
		const itemClass = "tools-row-menu__item" + (item.danger ? " tools-row-menu__item--danger" : "");
		return (
			<button type="button" key={item.label} role="menuitem" className={itemClass} onClick={() => this.onChooseItem(item)}>
				{item.label}
			</button>
		);
	};

	renderMenu = () => {
		const { items } = this.props;
		const { menuRect } = this.state;
		if (!menuRect) return null;

		const positionStyle = { top: menuRect.top, right: menuRect.right };
		const menu = (
			<div className="tools-row-menu__menu" style={positionStyle} ref={this.menuRef} role="menu">
				{items.map(this.renderItem)}
			</div>
		);
		return ReactDOM.createPortal(menu, document.body);
	};

	render() {
		const { label = "More actions" } = this.props;
		const { isOpen } = this.state;
		const triggerClass = "tools-row-menu__trigger" + (isOpen ? " tools-row-menu__trigger--open" : "");

		return (
			<span className="tools-row-menu" ref={this.triggerRef}>
				<button type="button" className={triggerClass} title={label} aria-label={label} aria-haspopup="menu" aria-expanded={isOpen} onClick={this.toggleMenu}>
					<Icon.MoreHorizontal size={16} />
				</button>
				{isOpen && this.renderMenu()}
			</span>
		);
	}
}

export default ToolsRowMenu;
